import { reactive } from 'vue'

export const writeOutcome = reactive({ inFlight: 0, uncertain: false })
export const uncertainWriteMessage = 'Не удалось подтвердить сохранение. Проверьте наличие документа и внесённых изменений перед повторной отправкой.'
const reported = new WeakSet()

export function isDataWrite(config) {
  if (!['post', 'put', 'patch', 'delete'].includes(config.method)) return false
  const path = (config.url || '').split('?')[0].replace(/^\/+|\/+$/g, '')
  if (config._skipSessionRecovery || config._readOnly || /^token(?:\/|$)/.test(path)) return false
  // These existing POST endpoints are reads/session operations, not data saves.
  if (config.method === 'post' && (path === 'devices/search' || path === 'profile' ||
      (path === 'devices' && !config.data))) return false
  return true
}

class WriteActivity {
  constructor() { this.finished = false; writeOutcome.inFlight++ }
  finish() {
    if (!this.finished) { this.finished = true; writeOutcome.inFlight-- }
  }
}
export function beginWrite(config) {
  if (isDataWrite(config) && !config._writeActivity) config._writeActivity = new WriteActivity()
}
export const finishWrite = config => config?._writeActivity?.finish()

export function reportUncertainWrite(original, finalError) {
  // A failed refresh is not an uncertain save: the original write was rejected with 401.
  if (!original.config?._writeActivity || finalError !== original ||
      ((original.__CANCEL__ || original.code === 'ERR_CANCELED') && !original.request)) return
  const status = original.response?.status
  if (status && status < 500) return
  if (!original.response && !['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_CANCELED'].includes(original.code)) return
  if (reported.has(original)) return
  reported.add(original)
  original.uncertainWrite = true
  writeOutcome.uncertain = true
}
